require('icons')

const Player = require('../player/player')

document.addEventListener("DOMContentLoaded",function(){
  Player.init()
})
